// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Schedule_wrapper__3j4nj","section":"Schedule_section__212EC"};